import React from 'react';
import { Tooltip } from '@mui/material';
import { Info as InfoIcon, InfoOutlined } from '@mui/icons-material';



const Info = ({ variant = 'outlined', className, sx, children, ...tooltipprops }) => {
	const Icon = variant === 'solid'
		? InfoIcon
		: InfoOutlined;

	return (
		<Tooltip enterTouchDelay={0}  {...tooltipprops} title={children}>
			<Icon className={className} sx={sx} />
		</Tooltip>
	);
};

export default Info;
